import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import flag from "../../../../../../assets/images/flag.png";
import FanGroupIcon from "../../../../../../assets/images/iconFan/expired-1.png";
import flag1 from "../../../../../../assets/images/Registration-End-01.1.png";

const ApprovedFanGroup = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let history = useHistory();
  let { slug } = useParams();

  const handleClick = () => {
    history.push("/superstar-admin/fangroup/view");
  };

  const [fanDetails, setFanDetails] = useState([]);
  const [fanId, setFanId] = useState("");
  const [myAdmin, setMyAdmin] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
        setMyAdmin(res.data.fanDetails.my_admin);
        setFanId(res.data.fanId);
      }
    });
  }, [slug]);

  return (
    <>
      <div className="container-lg">
        <div className="d-flex my-2">
          <img className="img-fluid" width="35px" src={FanGroupIcon} alt="" />
          <h3 className="text-white mx-2">Approved Fan Group</h3>
        </div>

        <div className="pendingGroupFan my-3">
          <div className="fanGroupBgImage w-100 fanGroupText d-flex justify-content-center align-items-center">
            <div>
              <h4 className="pendingTxt">Approved</h4>
              <h2 className="fanGroupTxt">FAN GROUP</h2>
            </div>
          </div>
        </div>

        <div className="row my-4">
          <div className="col-md-7 text-light d-flex flex-column align-items-center justify-content-center">
            <h2 className="titleFanName">{fanDetails.group_name}</h2>
            <p>
              <Markup content={fanDetails.description} />
            </p>
          </div>

          <div className="col-md-5">
            <div className="row registration-body  card-bg m-0 pt-3">
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Estimation Start:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {/* {moment(event.registration_start_date).format("LL")} */}
                      24 July, 2022
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag1} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Estimation End:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">25 July, 2022</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-wrap my-4">
          <div className="col-md-8 ">
            <div className="row">
              <div className="col-md-6">
                <div class="snip1527">
                  <div class="image">
                    <img
                      claName="shakibAdminImg img-fluid"
                      src={imageCdnUrl+fanDetails.my_superstar?.image}
                      alt="pr-sample23"
                    />
                  </div>
                  <figcaption>
                    <h3>
                      {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name}
                    </h3>

                    <p>
                      <big>
                        <span className="text-light">Status</span>:{" "}
                        {Number(fanDetails.my_star_status) === 1 ? (
                          <i className="text-warning fw-bold">Accepted</i>
                        ) : (
                          <i className="text-warning">Pending</i>
                        )}
                      </big>
                    </p>
                    <button className="btn btn-info w-100 mt-2">
                      Render Group
                    </button>
                  </figcaption>
                </div>
              </div>
              <div className="col-md-6">
                <div class="snip1527">
                  <div class="image">
                    <img
                      claName="shakibAdminImg img-fluid"
                      src={imageCdnUrl+fanDetails.another_superstar?.image}
                      alt="pr-sample23"
                    />
                  </div>
                  <figcaption>
                    <h3>
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name}
                    </h3>

                    <p>
                      <big>
                        <span className="text-light">Status</span>:{" "}
                        {Number(fanDetails.another_star_status) === 1 ? (
                          <i className="text-warning">Accepted</i>
                        ) : (
                          <i className="text-warning fw-bold">Pending</i>
                        )}
                      </big>
                    </p>
                    <button className="btn btn-info w-100 mt-2">
                      Render Group
                    </button>
                  </figcaption>
                </div>
              </div>
            </div>

          
          </div>

          <div className="col-md-4 ">
            <div className="bg-dark w-100 py-2">
              <div className="" style={{ borderLeft: "1px dashed yellow" }}>
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center ">
                  <div style={{ width: 200, height: 200 }}>
                    <CircularProgressbarWithChildren
                      value={100}
                      styles={buildStyles({
                        pathColor: `gold`,
                      })}
                    >
                      <div style={{ fontSize: 12, marginTop: -5 }}>
                        <strong className="text-light">100% complete</strong>
                      </div>
                    </CircularProgressbarWithChildren>
                    <p className="text-warning text-center my-2">
                      Approved by {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name} and{" "}
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

       
        </div>
      </div>
    </>
  );
};

export default ApprovedFanGroup;
